export enum Permissions {
  FULL_ACCESS = 'FULL_ACCESS',
  LIVE_ONLY = 'LIVE_ONLY',
  HISTORY = 'HISTORY',
}

export const PermissionsValues = Object.entries(Permissions).map(([key, value]) => value)
